export const SELECT_INDICE_VEGETACION = [
  { value: 'VISIBLE', viewValue: 'Imagen real' },
  { value: 'NDVI', viewValue: 'NDVI' },
  { value: 'GNDVI', viewValue: 'GNDVI' },
  { value: 'NDRE', viewValue: 'NDRE' },
  { value: 'EVI', viewValue: 'EVI' },
  { value: 'MSAVI', viewValue: 'MSAVI' },
  { value: 'ReCl', viewValue: 'ReCl' },
  { value: 'NDMI', viewValue: 'NDMI' },
  { value: 'NDWI', viewValue: 'NDWI' },
];

export const INDICE_TOOLTIP_TEXT = {
  NDVI: 'Muestra el vigor general del cultivo; valores altos significan plantas sanas y con mucha biomasa; valores bajos indican vegetación pobre o suelo desnudo.',
  GNDVI:
    'Similar al NDVI, pero más sensible a la cantidad de clorofila. Útil para detectar deficiencias de nutrientes (como nitrógeno) antes de que se noten a simple vista.',
  NDRE: 'Indica estrés en plantas adultas o en etapas tardías de crecimiento, cuando el NDVI ya no distingue bien diferencias de salud.',
  EVI: 'Proporciona una visión fiable de zonas con vegetación muy densa (bosques, cultivos muy frondosos), corrigiendo sombras y polvo en la atmósfera.',
  MSAVI:
    'Pensado para cultivos o parcelas con poca cobertura vegetal. Reduce el "ruido" del suelo para ver mejor la vegetación incipiente.',
  ReCI: 'Se centra en el contenido de clorofila, ideal para planificar fertilización nitrogenada o detectar estrés nutricional.',
  NDMI: 'Refleja la humedad en la planta y en el suelo. Valores altos = vegetación bien hidratada; valores bajos = estrés hídrico o sequedad.',
  NDWI: 'Detecta agua superficial o exceso de humedad en el terreno. Ayuda a ver encharcamientos o cuerpos de agua.',
  VISIBLE: 'Imagen real para la fecha seleccionada',
};
